'use strict';

module.exports = require('./lib/ReactScrolla');



//////////////////
// WEBPACK FOOTER
// ./~/react-scrolla/index.js
// module id = 581
// module chunks = 0